<template>
    <div class="news-page">
        <!-- 面包屑 -->
        <div class="crumb-bar">
            <div class="crumb-bar__inner">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{ $t('header_menu.home') }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ $t('header_menu.news') }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <!-- 页面标题 -->
        <div class="page-head">
            <span class="page-head__eyebrow">News Center</span>
            <h2 class="page-head__title">{{ $t('header_menu.news') }}</h2>
        </div>

        <div class="news-wrap">
            <!-- 列表 -->
            <div v-if="dataList.length" class="news-list">
                <div
                    v-for="item in dataList"
                    :key="item.id"
                    class="news-card"
                    @click="btnDetail(item.id)"
                >
                    <div class="news-card__image">
                        <img loading="lazy" :src="filePreUrl+item.coverUrl" :alt="item.title"
                             @error="e => e.target.src = defaultImg">
                    </div>
                    <div class="news-card__body">
                        <h3 class="news-card__title">{{ item.title }}</h3>
                        <span class="news-card__time">
                            <i class="el-icon-date"></i> {{ item.createTime }}
                        </span>
                        <p class="news-card__desc">{{ item.introduce }}</p>
                        <div class="news-card__action">
                            <span class="news-card__more">
                                {{ $t('read_more') }}
                                <i class="el-icon-arrow-right"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div v-else class="news-empty">
                <p>{{ $t('no_data') }}</p>
            </div>

            <!-- 分页 -->
            <div v-if="total > query.size" class="news-pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size="query.size"
                    :current-page="query.current"
                    :total="total"
                    @current-change="currentChange"
                />
            </div>
        </div>
    </div>
</template>
<script>
import {reqListNews} from "@/api/business/News";
import global from "@/api/global";
import defaultImg from "@/assets/core/no_img.jpg";

export default {
    name: "News",
    async created() {
        await this.load();
    },
    methods: {
        jump() {
            this.$router.push({path: '/news'})
        },
        async load() {
            let {data} = await reqListNews(this.query)
            this.dataList = data.records;
            this.total = data.total;
        },
        btnDetail(id) {
            this.$router.push({path: '/news/detail', query: {id: id}})
        },
        currentChange(num) {
            this.query.current = num;
            this.load();
        },
    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {
                current: 1,
                size: 10,
            },
            filePreUrl: global.preview_path_url,
            typeList: [],
        }
    }
}
</script>
<style scoped lang="scss">
$brand: #246543;
$brand-dark: #1b4d33;
$wood: #c08a4e;
$text: #2b2b2b;
$muted: #6b6b6b;
$line: #e8e8e8;

.news-page {
    background: #f5f5f5;
}

/* ===== 面包屑 ===== */
.crumb-bar {
    background: #fff;
    border-bottom: 1px solid $line;

    &__inner {
        max-width: 820px;
        margin: 0 auto;
        padding: 0 20px;

        :deep(.el-breadcrumb) {
            line-height: 50px;
        }
    }
}

/* ===== 页面标题 ===== */
.page-head {
    text-align: center;
    padding: 40px 0 22px;
    background: #fff;

    &__eyebrow {
        display: inline-block;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 2px;
        text-transform: uppercase;
        color: $wood;
        margin-bottom: 8px;
    }

    &__title {
        font-size: 32px;
        font-weight: 700;
        color: $brand-dark;
        margin: 0;
        line-height: 1.3;
    }
}

/* ===== 列表容器 ===== */
.news-wrap {
    max-width: 820px;
    margin: 0 auto;
    padding: 22px 20px 50px;
}

/* ===== 卡片列表 ===== */
.news-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.news-card {
    display: flex;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: box-shadow .3s ease, transform .3s ease;

    &:hover {
        box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);

        .news-card__more {
            color: $brand;
        }
    }

    &__image {
        flex-shrink: 0;
        width: 200px;
        height: 140px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
            transition: transform .5s ease;
        }

        &:hover img {
            transform: scale(1.05);
        }
    }

    &__body {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 16px 22px;
        min-width: 0;
    }

    &__title {
        font-size: 17px;
        font-weight: 700;
        color: $text;
        line-height: 1.45;
        margin: 0;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        transition: color .2s;
    }

    &__time {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        font-size: 12px;
        color: $muted;
        margin-top: 6px;

        i {
            color: $wood;
        }
    }

    &__desc {
        font-size: 13px;
        color: $muted;
        line-height: 1.65;
        margin: 8px 0 0;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    &__action {
        margin-top: auto;
        padding-top: 10px;
    }

    &__more {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        font-weight: 600;
        color: $brand-dark;
        transition: color .2s;

        i {
            font-size: 12px;
            transition: transform .2s;
        }
    }

    &:hover &__more i {
        transform: translateX(4px);
    }
}

/* ===== 空状态 ===== */
.news-empty {
    text-align: center;
    padding: 80px 0;
    color: $muted;
    font-size: 15px;
}

/* ===== 分页 ===== */
.news-pagination {
    display: flex;
    justify-content: center;
    margin-top: 28px;

    :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
        background-color: $brand;
    }

    :deep(.el-pagination.is-background .el-pager li:not(.disabled):hover) {
        color: $brand;
    }
}

/* ===== 响应式（保留手机端横向紧凑卡片风格，单套代码兼容 PC/移动） ===== */
@media (max-width: 768px) {
    /* 手机端隐藏面包屑，节省竖向空间 */
    .crumb-bar {
        display: none;
    }

    .page-head {
        padding: 28px 0 18px;

        &__title {
            font-size: 22px;
        }
    }

    .news-wrap {
        padding: 14px 14px 40px;
    }

    .news-list {
        gap: 14px;
    }

    /* 横向紧凑卡片：小图左、文字右（保留原手机端 MobileNews 的紧凑体验） */
    .news-card {
        border-radius: 14px;

        &:active {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        }

        &__image {
            width: 116px;
            flex: 0 0 116px;
            height: auto;
            align-self: stretch;
            border-radius: 14px 0 0 14px;
        }

        &__body {
            padding: 12px 14px;
        }

        &__title {
            font-size: 16px;
        }

        &__desc {
            -webkit-line-clamp: 2;
        }

        &__action {
            padding-top: 8px;
        }
    }
}
</style>
